import { render, staticRenderFns } from "./registration-view.vue?vue&type=template&id=06c4e8e0&scoped=true"
import script from "./registration-view.vue?vue&type=script&lang=js"
export * from "./registration-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c4e8e0",
  null
  
)

export default component.exports